import { Button, Col, Collapse, Layout, message, Space, Row } from "antd";
import React, { Component } from "react";
// import PropTypes from 'prop-types'
import { connect } from "react-redux";
import Breadcrumb from "../../components/Breadcrumb";
import {
  HmgMainDropdown,
  HmgDropdown,
} from "../../components/HmgHotelDropdown";
import {
  hmgmainGetHmgMain,
  projectGetIndexData,
  projectSaveIndexAutoPopulateData,
} from "../../store/actions/index";
import IndexMappingTable from "../../components/IndexManagement/IndexAutoPopulate/IndexMappingTable";
import { flatten, findLastIndex, uniqueId, difference, orderBy } from "lodash";

const { Panel } = Collapse;

export class IndexMapping extends Component {
  // static propTypes = {
  //     prop: PropTypes
  // }

  constructor(props) {
    super(props);

    this.state = {
      hmgmainSelect: undefined,
      projectSelect: undefined,
      hmgmainList: [],
      projectList: [],
      allIndexes: [],
      selectedCols: [],
      rows: [],
    };
  }

  changeHmgMainSelect = (e) => {
    this.setState(
      {
        hmgmainSelect: e,
        projectSelect: undefined,
        projectList: [],
        allIndexes: [],
        selectedCols: [],
        rows: [],
      },
      () => {
        // console.log(this.state,'hmg main changed')
      }
    );
  };

  handleProjectChange = async (e) => {
    const returndata = await this.props.projectGetIndexData(e);
    let selectedColList = [];
    let rows = [];
    let invalidIndexes = [];
    let allIndexes =
      returndata !== undefined
        ? orderBy(returndata.indexes, [(index) => index.name.toLowerCase()])
        : [];

    if (
      returndata !== undefined &&
      returndata.project !== undefined &&
      returndata.project.index_mapping !== undefined
    ) {
      const validIndexIds = allIndexes.map((el) => el._id);
      if (
        Array.isArray(returndata.project.index_mapping.index_mapping_columns)
      ) {
        selectedColList =
          returndata.project.index_mapping.index_mapping_columns;
        selectedColList.forEach((scl) => {
          delete scl._id;
          scl.index_id = validIndexIds.includes(scl.index_id)
            ? scl.index_id
            : undefined;
          scl.uniqueId = uniqueId();
        });
      }
      if (Array.isArray(returndata.project.index_mapping.index_mapping_data)) {
        rows = returndata.project.index_mapping.index_mapping_data;
        rows.forEach((row) => {
          row.forEach((rowElm, elindex) => {
            delete rowElm._id;
            const relcol = selectedColList[elindex];

            const indexFromAllocated = allIndexes.find(
              (sle) => sle._id === rowElm.index_id
            );
            if (relcol !== undefined) {
              rowElm.index_id = relcol.index_id;
              rowElm.uniqueId = relcol.uniqueId;
              if (rowElm.index_id === undefined) {
                rowElm.value = undefined;
              }
            }

            if (indexFromAllocated !== undefined) {
              rowElm.value = indexFromAllocated.values.includes(rowElm.value)
                ? rowElm.value
                : undefined;
            }
          });
        });
      }
    }

    if (selectedColList.length === 0) {
      selectedColList = [
        {
          index_id: undefined,
          type: 1,
          uniqueId: uniqueId(),
        },
        {
          index_id: undefined,
          type: 2,
          uniqueId: uniqueId(),
        },
        {
          index_id: undefined,
          type: 2,
          uniqueId: uniqueId(),
        },
        {
          index_id: undefined,
          type: 2,
          uniqueId: uniqueId(),
        },
        {
          index_id: undefined,
          type: 2,
          uniqueId: uniqueId(),
        },
      ];

      for (let i = 0; i < 4; i++) {
        const emptyList = [];
        selectedColList.forEach((el) => {
          emptyList.push({
            index_id: el.index_id,
            value: undefined,
            uniqueId: el.uniqueId,
          });
        });
        rows.push(emptyList);
      }
    }

    this.setState(
      {
        projectSelect: e,
        allIndexes: allIndexes,
        selectedCols: selectedColList,
        rows: rows,
      },
      () => {
        console.log(this.state, "project change");
      }
    );
  };

  getProjectList = (e) => {
    const hmgselected = this.state.hmgmainList.find((el) => el._id === e);
    if (hmgselected !== undefined) {
      return hmgselected.projects;
    }
    return [];
  };

  async componentDidMount() {
    const result = await this.props.hmgmainGetHmgMain();
    this.setState({
      hmgmainList: result,
    });
  }

  addColumn = (type) => {
    const colList = [...this.state.selectedCols];
    const lastIndex = findLastIndex(colList, (el) => el.type === type);

    if (
      lastIndex !== -1 &&
      this.state.selectedCols.length < this.state.allIndexes.length
    ) {
      const uniqid = uniqueId();
      colList.splice(lastIndex + 1, 0, {
        type: type,
        index_id: undefined,
        uniqueId: uniqid,
      });

      const rowdata = [...this.state.rows];
      rowdata.forEach((row) => {
        row.splice(lastIndex + 1, 0, {
          index_id: undefined,
          value: undefined,
          uniqueId: uniqid,
        });
      });

      this.setState({
        selectedCols: colList,
        rows: rowdata,
      });
    }
  };

  removeColumn = (uniqueId) => {
    const colindex = this.state.selectedCols.findIndex(
      (el) => el.uniqueId === uniqueId
    );
    if (colindex !== -1) {
      if (
        this.state.selectedCols.filter(
          (rtx) => rtx.type === this.state.selectedCols[colindex].type
        ).length > 1
      ) {
        const cols = [...this.state.selectedCols];
        cols.splice(colindex, 1);

        const dataset = [...this.state.rows];

        dataset.forEach((row) => {
          const rowIndex = row.findIndex((rt) => rt.uniqueId === uniqueId);
          if (rowIndex !== -1) {
            row.splice(rowIndex, 1);
          }
        });

        this.setState({
          selectedCols: cols,
          rows: dataset,
        });
      }
    }
  };

  addRow = () => {
    const dataArray = [...this.state.rows];
    const emptyList = [];

    this.state.selectedCols.forEach((el) => {
      emptyList.push({
        index_id: el.index_id,
        value: undefined,
        uniqueId: el.uniqueId,
      });
    });
    dataArray.push(emptyList);
    this.setState({
      rows: dataArray,
    });
  };

  updateDataRecord = (index, _id, val) => {
    const dataSet = [...this.state.rows];
    const elmIndex = dataSet[index].findIndex((el) => el.uniqueId === _id);
    if (elmIndex !== -1) {
      dataSet[index][elmIndex].value = val;
    }
    this.setState({
      rows: dataSet,
    });
  };

  getColumns = (_id = null) => {
    const selectedIndexes = this.state.selectedCols.map((rt) => rt.index_id);
    return this.state.allIndexes.filter(
      (el) => !selectedIndexes.includes(el._id) || el._id === _id
    );
  };

  getIndexOptions = (_id, rowIndex) => {
    // console.log(_id,rowIndex,'get index options')
    const selectedCol = this.state.selectedCols.find(
      (rt) => rt.index_id === _id
    );
    if (_id !== undefined && selectedCol !== undefined) {
      const indexelm = this.state.allIndexes.find((el) => el._id === _id);
      const rowset = this.state.rows
        .filter((rl, rinx) => rinx !== rowIndex)
        .map((el) => {
          return el.find((rx) => rx.index_id === _id);
        })
        .filter((td) => td !== undefined)
        .map((std) => std.value)
        .filter((sfx) => sfx !== undefined);
      // const rowset = this.state.rows.filter((el,index)=>index!==rowIndex)

      // console.log(indexelm,rowset,'index elm')
      if (indexelm !== undefined) {
        return indexelm.values.filter((el) => {
          if (selectedCol.type === 1) {
            return !rowset.includes(el);
          } else {
            return true; // to show all indexes for secondary indexes
          }
          //return true // to show all indexes
        });
      }
    }
    return [];
  };

  updateColumn = (uniqueId, type, val) => {
    const dataSet = [...this.state.selectedCols];
    const elementIndex = dataSet.findIndex((el) => el.uniqueId === uniqueId);

    dataSet[elementIndex].type = type;
    dataSet[elementIndex].index_id = val;

    //clear old allocated indexes
    const rowdata = [...this.state.rows];
    rowdata.forEach((row) => {
      const innerIndex = row.findIndex((rl) => rl.uniqueId === uniqueId);

      if (innerIndex !== -1) {
        row[innerIndex].index_id = val;
        row[innerIndex].value = undefined;
      }
    });

    this.setState({
      selectedCols: dataSet,
      rows: rowdata,
    });
    // console.log(index,type,val,'update column')
  };

  remove = (index) => {
    const dataSet = [...this.state.rows];
    dataSet.splice(index, 1);
    this.setState({
      rows: dataSet,
    });
  };

  validate = () => {
    if (
      this.state.selectedCols.findIndex((el) => el.index_id === undefined) !==
        -1 ||
      flatten(this.state.rows).find((el) => el.value === undefined) !==
        undefined
    ) {
      message.error("Please fill all the fields");
      return false;
    }
    return true;
  };

  submitIndexAllocation = async () => {
    if (this.validate()) {
      // console.log('all fields are valid')
      const colList = [...this.state.selectedCols].map((cl) => {
        const colEl = { ...cl };
        delete colEl.uniqueId;
        return colEl;
      });

      const rows = [];
      this.state.rows.forEach((row) => {
        const updatedrow = row.map((el) => {
          const rowElm = { ...el };
          delete rowElm.uniqueId;
          return rowElm;
        });
        rows.push(updatedrow);
      });

      // console.log(colList,rows,'before send')

      // if(false){
      const result = await this.props.projectSaveIndexAutoPopulateData({
        project_id: this.state.projectSelect,
        cols: colList.map((e) => {
          const colElm = { ...e };
          delete colElm.uniqueId;
          return colElm;
        }),
        rows: rows,
      });
      if (result) {
        this.handleProjectChange(this.state.projectSelect);
      }
      // }
    }
  };

  reset = () => {
    const selectedCols = [
      {
        index_id: undefined,
        type: 1,
        uniqueId: uniqueId(),
      },
      {
        index_id: undefined,
        type: 2,
        uniqueId: uniqueId(),
      },
      {
        index_id: undefined,
        type: 2,
        uniqueId: uniqueId(),
      },
      {
        index_id: undefined,
        type: 2,
        uniqueId: uniqueId(),
      },
      {
        index_id: undefined,
        type: 2,
        uniqueId: uniqueId(),
      },
    ];
    const rows = [];

    for (let i = 0; i < 4; i++) {
      const emptyList = [];
      selectedCols.forEach((el) => {
        emptyList.push({
          index_id: el.index_id,
          value: undefined,
          uniqueId: el.uniqueId,
        });
      });
      rows.push(emptyList);
    }

    this.setState({
      selectedCols: selectedCols,
      rows: rows,
    });
  };

  render() {
    return (
      <div>
        <Layout>
          <div className="container_aa">
            <h3>Index Auto Populate</h3>
            <Breadcrumb
              routes={[
                { path: "/", breadcrumbName: "Dashboard" },
                {
                  path: "/index/mapping",
                  breadcrumbName: "Index Auto Populate",
                },
              ]}
            />
          </div>
          <div className="container_ab">
            <Collapse defaultActiveKey={[1]} expandIconPosition="end">
              <Panel key={1} header="Index Auto Populate">
                <HmgMainDropdown
                  hmgmainSelect={this.state.hmgmainSelect}
                  hmgmainList={this.state.hmgmainList}
                  hmgmainChange={this.changeHmgMainSelect}
                />
                <HmgDropdown
                  hmgSelect={this.state.projectSelect}
                  handleHmgChange={this.handleProjectChange}
                  loadHotelList={() => {}}
                  projectList={this.getProjectList(this.state.hmgmainSelect)}
                />
                {(this.state.hmgmainSelect !== undefined &&
                  this.state.projectSelect !== undefined) ||
                true ? (
                  <div style={{ paddingTop: "24px" }}>
                    <IndexMappingTable
                      allIndexes={this.state.allIndexes}
                      selectedCols={this.state.selectedCols}
                      indexOptions={this.state.indexOptions}
                      rows={this.state.rows}
                      remove={this.remove}
                      updateDataRecord={this.updateDataRecord}
                      updateColumn={this.updateColumn}
                      getColumns={this.getColumns}
                      addColumn={this.addColumn}
                      removeColumn={this.removeColumn}
                      addRow={this.addRow}
                      getIndexOptions={this.getIndexOptions}
                    />
                  </div>
                ) : null}
                {this.state.hmgmainSelect !== undefined &&
                this.state.projectSelect !== undefined ? (
                  <Row justify="center">
                    <Space direction="horizontal">
                      <Button
                        disabled={
                          !(
                            this.state.hmgmainSelect !== undefined &&
                            this.state.projectSelect !== undefined &&
                            this.state.rows.length > 0
                          )
                        }
                        onClick={this.submitIndexAllocation}
                        type="primary"
                      >
                        Update
                      </Button>
                      <Button onClick={this.reset}>Cancel</Button>
                    </Space>
                  </Row>
                ) : null}
              </Panel>
            </Collapse>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  hmgmainGetHmgMain: () => dispatch(hmgmainGetHmgMain()),
  projectGetIndexData: (id) => dispatch(projectGetIndexData(id)),
  projectSaveIndexAutoPopulateData: (data) =>
    dispatch(projectSaveIndexAutoPopulateData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IndexMapping);
